import sdk from '@/sdk';
import {getCardLikeInfo, updateCardLikeInfo} from '@/store/util';

export async function handleCardMerge(data: any, docGuid: string, action: number) {
    try {
        const [remainedBlockId, removedBlockId] = data.blockIds;
        const ksServer = await sdk.getKsServer();
        await ksServer.cardChange({
            toBlockId: remainedBlockId,
            blockId: removedBlockId,
            docGuid,
            action,
        });
        let userLike = false;
        // 编辑模式合并卡片更新下本地缓存数据，防止新数据获取失败
        const allLikeCount = getCardLikeInfo(docGuid, data.blockIds).reduce((prev, cur) => {
            if (prev?.userLike) {
                userLike = true;
            }
            return prev?.likeCount + cur?.likeCount;
        }, 0);
        // 更新remainedBlockId的点赞数量 移除removedBlockId的点赞信息
        updateCardLikeInfo(docGuid, [
            {
                blockId: remainedBlockId,
                likeCount: allLikeCount || 0,
                userLike: userLike,
            },
            { // 理论上要删除的 懒得删除了
                blockId: removedBlockId,
                likeCount: 0,
                userLike: false,
            },
        ]);
    } catch (err) {
        console.log(err);
    }

}
